import React from 'react'
import classNames from 'classnames'

const InputText = ({ error, touched = true, ...props }) => (
  <div className="control">
    <input
      className={classNames('input', { 'is-danger': error && touched })}
      type="text"
      {...props}
    />
    {
      touched && <p className={classNames('help', { 'is-danger': error })}> {error} </p>
    }
  </div>
)

export default InputText



// WEBPACK FOOTER //
// ./src/components/views/widgets/InputText.js